import Headroom from "headroom.js";

export function leftAlignedMegamenu() {
  // if megamenu
  if(document.querySelector('#headerLeftAligned') && document.querySelector('.list-item-left-aligned-toggle')){

		const toggleElements = [...document.querySelectorAll('.list-item-left-aligned-toggle')];


			const isCollapsed = document.querySelector('.collapsed-menu');
	
			toggleElements.forEach(item => {
	
			//toggle function for desktop
			if(window.innerWidth > 768 && !isCollapsed){
				item.addEventListener('click', event => {
					if(true){
						event.preventDefault()
						let isVisible = item.nextElementSibling.classList.contains('visible');
						
						let activeMenus = item.closest('ul').querySelectorAll('.visible')
						if(activeMenus[0] != undefined){
							activeMenus.forEach(item => {
								item.classList.remove('visible')
								item.previousElementSibling.setAttribute('aria-expanded', 'false')
								item.previousElementSibling.classList.remove('active')
							})
						}
						if(isVisible){
							item.nextElementSibling.classList.remove('visible');
							item.setAttribute('aria-expanded', 'false')
							item.classList.remove('active')
						} else if (!isVisible) {
							item.nextElementSibling.classList.add('visible');
							item.setAttribute('aria-expanded', true)          
							item.classList.add('active')
						}
					} else {
						return
					}
				})
	
				//toggle function for mobile
				} else if (window.innerWidth < 769 || isCollapsed){
					item.addEventListener('click', () => {
						item.nextElementSibling.classList.toggle('visible')
						if(item.getAttribute('aria-expanded') == 'false'){
							item.setAttribute('aria-expanded', true)
							item.querySelector('.list-item-megamenu-toggle-icon').style.transform = 'translateY(0%) rotate(315deg)'
						} else {
							item.setAttribute('aria-expanded', 'false')
							item.querySelector('.list-item-megamenu-toggle-icon').style.transform = 'translateY(-50%) rotate(135deg)'
						}
					})
				}
			})
	
			//hover intent for desktop
			if(window.innerWidth > 768 && !isCollapsed){
				// Store a reference to the timeout
				let hoverIntentTimeout;
	
				// Function to be executed when hover intent is triggered
				function handleHoverIntent(element) {
					listElements.forEach(element => {
						element.classList.remove('visible')
					})
					element.classList.add("visible");
				}
	
				// Function to be executed when hover intent is not triggered
				function handleHoverOut(element) {
					hoverIntentTimeout = setTimeout(() => {
						listElements.forEach(element => {
							element.classList.remove('visible')
						})
						//element.classList.remove("visible");
					}, 300); // Delay removal in milliseconds
				}
	
				// Add event listeners to all list elements
				const listElements = document.querySelectorAll(".sidemenu-list-item");

				

				listElements.forEach(element => {
					element.addEventListener("mouseenter", () => {
						//Only hover if not collapsed menu
						if(!document.querySelector('.collapsed-menu')){
							// Clear previous timeout (if any)
							clearTimeout(hoverIntentTimeout);
		
							// Set a new timeout to trigger hover intent after a delay
							hoverIntentTimeout = setTimeout(() => {
								handleHoverIntent(element);
							}, 300); // Delay in milliseconds
						}
					});
	
					element.addEventListener("mouseleave", () => {
						//Only hover effect if no collapsed menu
						if(!document.querySelector('.collapsed-menu')){
							// Clear the timeout when leaving the element
							clearTimeout(hoverIntentTimeout);
		
							// Handle hover out
							handleHoverOut(element);
						}
					});
				});
			}
	  
	
			
		}
	if(document.querySelector('#headerLeftAligned')){
		const menuElement = document.querySelector('.header--left-aligned-container');
		const mainElement = document.querySelector('main');

		function getHeaderHeight() {
			return document.querySelector('.collapsed-menu')
				? document.querySelector('.header--left-aligned-top-bar').offsetHeight
				: menuElement.offsetHeight;
		}

		function updateMainPadding() {
			mainElement.style.paddingTop = getHeaderHeight() + 'px';
		}

		updateMainPadding();

		const headroom = new Headroom(menuElement, {
			offset: getHeaderHeight(),
			tolerance: 5,
			onPin: function() {
				menuElement.classList.remove('suggestions-hidden');
			},
			onUnpin: function() {
				menuElement.classList.add('suggestions-hidden');
			},
			onTop: function() {
				menuElement.classList.remove('suggestions-hidden');
			}
		});
		headroom.init();

		window.addEventListener('resize', function() {
			updateMainPadding();
			headroom.offset = getHeaderHeight();
		});
	}
		
}

export default leftAlignedMegamenu;
